import request from '@/util/request';
import qs from 'qs';



// 仪表名称选择树 /v4ward/iot/device/meterTree

export const meterTree = (params, options) =>
    request.get('/api/v4ward/iot/device/deptCostIotDeviceTree', Object.assign({}, options, { params }));

//     列表分页 /v4ward/energy/setting/dept/cost/page
export const getList = (params, options) =>
    request.get('/api/v4ward/energy/setting/dept/cost/page', Object.assign({}, options, { params }));

//     获取当前登录人部门及子部门节点树/v4ward/dept/treeByIds
export const treeByIds = (params, options) =>
    request.get('/api/v4ward/dept/treeByIds', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/energy/setting/dept/cost/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/energy/setting/dept/cost/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/energy/setting/dept/cost/update', params,options)

// 根据部门能耗id获取指标周期集合
export const getListByDeptCostId = (params, options) =>
    request.get('/api/v4ward/energy/setting/dept/cost/cycle/getListByDeptCostId', Object.assign({}, options, { params }));

// 根据部门能耗id获取指标参数集合 //v4ward/energy/setting/dept/cost/meter/getListByDeptCostId
export const metergetListByDeptCostId = (params, options) =>
    request.get('/api/v4ward/energy/setting/dept/cost/meter/getListByDeptCostId', Object.assign({}, options, { params }));